import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/(redirects)/fleet')({
  component: () => <Navigate to="/enterprise" />,
});
